import { intl } from '@trello/i18n';

export const getViewMessages = (viewName: string) => {
  switch (viewName) {
    case 'Board':
      return intl.formatMessage({
        id: 'templates.view_switcher.Board',
        defaultMessage: 'Board',
        description: 'Switch to Board view.',
      });
    case 'Table':
      return intl.formatMessage({
        id: 'templates.view_switcher.Table',
        defaultMessage: 'Table',
        description: 'Switch to Table view.',
      });
    case 'Calendar':
      return intl.formatMessage({
        id: 'templates.view_switcher.Calendar',
        defaultMessage: 'Calendar',
        description: 'Switch to Calendar view.',
      });
    case 'Map':
      return intl.formatMessage({
        id: 'templates.view_switcher.Map',
        defaultMessage: 'Map',
        description: 'Switch to Map view.',
      });
    case 'Timeline':
      return intl.formatMessage({
        id: 'templates.view_switcher.Timeline',
        defaultMessage: 'Timeline',
        description: 'Switch to Timeline view.',
      });
    case 'Dashboard':
      return intl.formatMessage({
        id: 'templates.view_switcher.Dashboard',
        defaultMessage: 'Dashboard',
        description: 'Switch to Dashboard view.',
      });
    default:
      return intl.formatMessage({
        id: 'templates.view_switcher.Dashboard',
        defaultMessage: 'Dashboard',
        description: 'Switch to Dashboard view.',
      });
  }
};
